module.exports = __webpack_public_path__ + "img/kills.1f13adb3.png";